import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CourseService } from '../shared/services/course.service';
import { TagService } from '../shared/services/tag.service';

import { Course } from '../shared/models/course.model';
import { Observable } from 'rxjs/Rx';

import 'rxjs/add/operator/catch';

@Injectable()
export class CourseDetailResolve implements Resolve<any> {

  constructor(
      private courseService: CourseService,
      private router: Router
  ) {}
  
  resolve(route: ActivatedRouteSnapshot) {
    return this.courseService.getCourseById(route.params['id'])
      .catch((err) => this.router.navigateByUrl('/courses/all'));;
  }

  
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/course-detail/course-detail.resolve.ts